<template>
  <div class="self-media-container">
    <p class="section-title-line">
      <span>自媒体矩阵</span>
    </p>
    <div class="section-container">
      <el-row class="top-qr-box">
        <el-col :span="12">
          <div class="top-qr-code">
            <img src="../../../assets/images/selfMedia/1.jpg" alt="" />
            <p>新希望集团 微信公众号</p>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="top-qr-code">
            <img src="../../../assets/images/selfMedia/2.jpeg" alt="" />
            <p>新希望地产 微信公众号</p>
          </div>
        </el-col>
      </el-row>
      <p class="main-title">新希望地产城市公司微信公众号</p>

      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>C</p>
          </div>
        </el-col>
        <el-col :span="18" class="city-box">
          <div class="city-text-item">
            <p>成都新希望地产</p>
            <img src="../../../assets/images/selfMedia/3.jpg" alt="" />
          </div>
          <div class="city-text-item">
            <p>重庆新希望地产</p>
            <img src="../../../assets/images/selfMedia/4.jpg" alt="" />
          </div>
        </el-col>
      </el-row>

      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>D</p>
          </div>
        </el-col>
        <el-col :span="18" class="city-box">
          <div class="city-text-item">
            <p>大连新希望地产</p>
            <img src="../../../assets/images/selfMedia/5.jpg" alt="" />
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>H</p>
          </div>
        </el-col>
        <el-col :span="18" class="city-box">
          <div class="city-text-item">
            <p>杭州新希望地产</p>
            <img src="../../../assets/images/selfMedia/6.jpg" alt="" />
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>J</p>
          </div>
        </el-col>
        <el-col :span="18" class="city-box">
          <div class="city-text-item">
            <p>济南新希望地产</p>
            <img src="../../../assets/images/selfMedia/7.jpg" alt="" />
          </div>
          <div class="city-text-item">
            <p>嘉兴新希望地产</p>
            <img src="../../../assets/images/selfMedia/8.jpg" alt="" />
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>K</p>
          </div>
        </el-col>
        <el-col :span="18" class="city-box">
          <div class="city-text-item">
            <p>昆明新希望地产</p>
            <img src="../../../assets/images/selfMedia/9.jpg" alt="" />
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>N</p>
          </div>
        </el-col>
        <el-col :span="18" class="city-box">
          <div class="city-text-item">
            <p>南宁新希望地产</p>
            <img src="../../../assets/images/selfMedia/10.jpg" alt="" />
          </div>
          <div class="city-text-item">
            <p>宁波新希望地产</p>
            <img src="../../../assets/images/selfMedia/11.jpg" alt="" />
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>S</p>
          </div>
        </el-col>
        <el-col :span="18" class="city-box">
          <div class="city-text-item">
            <p>沈阳新希望地产</p>
            <img src="../../../assets/images/selfMedia/12.jpg" alt="" />
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>W</p>
          </div>
        </el-col>
        <el-col :span="18" class="city-box">
          <div class="city-text-item">
            <p>温州新希望地产</p>
            <img src="../../../assets/images/selfMedia/13.jpg" alt="" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "SelfMediaPage",
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
      // 手动触发滚动事件
      const event = new Event("scroll");
      window.dispatchEvent(event);
    });
  },
};
</script>
<style lang="scss" scoped>
.self-media-container {
  .top-qr-box {
    background-color: #f1f2f3;
    box-sizing: border-box;
    padding: 0 120px;

    .top-qr-code {
      text-align: center;
      margin: 60px 0;
      > img {
        width: 180px;
        height: auto;
      }

      > p {
        color: #2d2d2d;
        border-radius: 4px;
        margin-top: 20px;
        margin-right: auto;
        margin-left: auto;
        width: 266px;
        height: 37px;
        line-height: 37px;
        font-size: 16px;
      }
    }
  }

  .main-title {
    color: #272727;
    padding-bottom: 30px;
    padding-top: 40px;
    font-size: 22px;
  }

  .word-list-item {
    color: #000000;
    border-bottom: 1px dashed #7a7a7a;
  }

  .filter-item {
    height: 110px;

    > p {
      transition: all 0.3s ease-in-out;
      margin-top: 30px;
      color: #3c4347;
      font-size: 84px;
      line-height: 80px;
    }
  }

  .city-box {
    overflow: hidden;

    .city-text-item {
      box-sizing: border-box;
      padding-top: 40px;
      padding-bottom: 40px;
      float: left;
      height: 300px;
      font-size: 12px;
      color: #565c61;
      line-height: 20px;
      transition: all 0.3s ease-in-out;
      width: 50%;
      text-align: center;

      > p {
        font-size: 22px;
        color: #3c4347;
        line-height: 22px;
        margin-bottom: 20px;
        transition: all 0.3s ease-in-out;
        text-align: center;
      }

      > img {
        width: 150px;
        margin-top: 15px;
        height: auto;
      }
    }
  }
}
</style>
